import { render, staticRenderFns } from "./RoleUpdate.vue?vue&type=template&id=1a5349be&scoped=true"
import script from "./RoleUpdate.vue?vue&type=script&lang=js"
export * from "./RoleUpdate.vue?vue&type=script&lang=js"
import style0 from "./RoleUpdate.vue?vue&type=style&index=0&id=1a5349be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5349be",
  null
  
)

export default component.exports